const isBlankPivotValue = (value) =>
  value == null || String(value).trim() === "";

/**
 * Drops blank pivot values (e.g. `{ vendorType: [" "] }`) and the pivots left
 * with no values. Returns null when no pivot remains.
 */
export const stripBlankPivotValues = (pivotFilter) => {
  const cleaned = {};
  Object.entries(pivotFilter || {}).forEach(([key, values]) => {
    if (Array.isArray(values)) {
      const kept = values.filter((value) => !isBlankPivotValue(value));
      if (kept.length > 0) cleaned[key] = kept;
    } else if (!isBlankPivotValue(values)) {
      cleaned[key] = values;
    }
  });
  return Object.keys(cleaned).length > 0 ? cleaned : null;
};

const hasBlankPivotValue = (pivotFilter) =>
  Object.values(pivotFilter).some((values) =>
    Array.isArray(values)
      ? values.length === 0 || values.some(isBlankPivotValue)
      : isBlankPivotValue(values)
  );

/**
 * Request payloads carry dashboard pivots as `pivotFilter`. Blank values (from
 * an empty pivot slice, an old URL or a saved search) are not a meaningful
 * filter, so strip them before sending; when nothing is left, drop the pivot
 * keys the same way the dashboard does when no pivot is selected. Payloads
 * without blank pivot values are returned untouched.
 */
export const withoutBlankPivotValues = (payload) => {
  const pivotFilter = payload?.pivotFilter;
  if (
    !pivotFilter ||
    typeof pivotFilter !== "object" ||
    Array.isArray(pivotFilter) ||
    !hasBlankPivotValue(pivotFilter)
  ) {
    return payload;
  }
  const cleaned = stripBlankPivotValues(pivotFilter);
  if (cleaned) return { ...payload, pivotFilter: cleaned };
  const { pivotFilter: _pivots, pivots_operator: _operator, ...rest } = payload;
  return rest;
};
